export default __webpack_public_path__ + "static/media/employees.de047975.svg";